import { useEffect, useState } from "react";

// Ce que l'administration a refermé : boutique, inscriptions, signalement de
// bug, modes de jeu. Lu une fois au démarrage ; le serveur refuse de toute
// façon ces actions, ceci ne sert qu'à masquer ce qui ne mène nulle part.
// Tant que la réponse n'est pas arrivée, tout est supposé ouvert.
const API = process.env.REACT_APP_API_URL || "";
let current = { shop: true, register: true, bugReport: true, modes: null };
let loading = null;
const listeners = new Set();

function load() {
  if (!loading) {
    loading = fetch(`${API}/features`)
      .then(r => (r.ok ? r.json() : null))
      .then(d => { if (d) { current = { ...current, ...d }; listeners.forEach(fn => fn(current)); } })
      .catch(() => {});
  }
  return loading;
}

export function useFeatures() {
  const [features, setFeatures] = useState(current);
  useEffect(() => {
    listeners.add(setFeatures);
    load();
    return () => listeners.delete(setFeatures);
  }, []);
  return features;
}
